import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormOctagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-octagon"><path d="M14.5889 2C15.5834 2.00001 16.537 2.39538 17.2402 3.09863L20.9014 6.75977C21.6046 7.46302 22 8.41658 22 9.41113V14.5889C22 15.5834 21.6046 16.537 20.9014 17.2402L17.2402 20.9014C16.537 21.6046 15.5834 22 14.5889 22H9.41113C8.41658 22 7.46302 21.6046 6.75977 20.9014L3.09863 17.2402C2.39538 16.537 2.00001 15.5834 2 14.5889V9.41113C2.00001 8.41658 2.39538 7.46302 3.09863 6.75977L6.75977 3.09863C7.46302 2.39538 8.41658 2.00001 9.41113 2H14.5889Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormOctagon;
